import React from "react";
import "../../Components/Boot/Boot.css";
import "./PrivacyPolicy.css";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import MobileFooter from "../../Components/Mobile/MobileFooter";

function PrivacyPolicy() {
  return (
    <div>
      <Navbar />
      <div className="privacy-wrapper d-flex align-items-center justify-content-center mb-3">
        <div className="privacy-container">
          <h1>TB Mart - Privacy Policy</h1>
          <p className="last-updated">Last Updated: August 11, 2025</p>

          <section>
            <h2>1. Introduction and Scope</h2>
            <p>
              Welcome to TB Mart. Your privacy is of the utmost importance to
              us. This Privacy Policy outlines how TrendBay Daily Solutions Ltd
              ("we," "us," "our," or "TB Mart") collects, uses, shares, and
              protects your personal information when you use our website,
              mobile application, and related services (collectively, the
              "Service").
            </p>
            <p>
              This policy is designed to be transparent and compliant with the
              Nigeria Data Protection Regulation (NDPR) and other applicable
              data protection laws. By using our Service, you agree to the
              collection and use of information in accordance with this policy.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>2.1. Personal Data You Provide:</h3>
            <ul>
              <li>
                <strong>Account Information:</strong> When you register for an
                account, we collect your full name, email address and phone
                number.
              </li>
              <li>
                <strong>Communication Data:</strong> If you contact us directly,
                we may receive additional information such as the contents of
                your message and any attachments.
              </li>
            </ul>

            <h3>2.2. Transactional and Payment Information:</h3>
            <ul>
              <li>
                <strong>Order Details:</strong> We collect information about
                your orders, including the products you purchase, order history,
                and preferences.
              </li>
              <li>
                <strong>Payment Information:</strong> We do not directly store
                your full credit/debit card details. All online payments are
                processed through secure, PCI-compliant third-party payment
                gateways. We may collect information necessary to process
                payments for other methods like Bank Transfer or Cash on
                Delivery.
              </li>
            </ul>

            <h3>2.3. Data Collected Automatically (Usage Data):</h3>
            <ul>
              <li>
                <strong>Device Information:</strong> We collect information
                about the device you use to access our Service, including your
                IP address, operating system, browser type, and unique device
                identifiers.
              </li>
              <li>
                <strong>Usage Information:</strong> We log how you interact with
                our Service, such as the pages you visit, features you use,
                search queries, and the time, frequency, and duration of your
                activities.
              </li>
            </ul>

            <h3>2.4. Cookies and Tracking Technologies:</h3>
            <p>
              We use cookies, beacons, and similar technologies to collect
              information about your browsing activities. This helps us
              personalize your experience, remember your preferences, and
              analyze our website's performance. For more details, see Section 7
              below.
            </p>
          </section>

          <section>
            <h2>3. How and Why We Use Your Information</h2>
            <ul>
              <li>
                <strong>To Provide and Manage the Service:</strong> To process
                your orders, manage your account, facilitate deliveries, and
                process payments. (Legal Basis: Performance of a contract)
              </li>
              <li>
                <strong>To Communicate With You:</strong> To send you order
                confirmations, delivery updates, and respond to your customer
                service inquiries. (Legal Basis: Performance of a contract)
              </li>
              <li>
                <strong>For Marketing and Promotions:</strong> To inform you
                about special offers, new products, and promotions that may
                interest you. You can opt out of marketing communications at any
                time. (Legal Basis: Consent)
              </li>
              <li>
                <strong>For Analytics and Improvement:</strong> To understand
                how our users interact with the Service, allowing us to improve
                functionality, user experience, and our product offerings.
                (Legal Basis: Legitimate interest)
              </li>
              <li>
                <strong>For Security and Fraud Prevention:</strong> To protect
                our Service, our users, and the public from fraud, abuse, and
                security risks. (Legal Basis: Legitimate interest)
              </li>
              <li>
                <strong>To Comply with Legal Obligations:</strong> To meet our
                legal and regulatory requirements. (Legal Basis: Legal
                obligation)
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Data Sharing and Third-Party Disclosures</h2>
            <ul>
              <li>
                <strong>Delivery Partners:</strong> We share your name, delivery
                address, and phone number with our delivery riders and logistics
                partners to fulfill your orders.
              </li>
              <li>
                <strong>Payment Processors:</strong> We share transaction
                information with our payment gateway partners to process your
                payments securely.
              </li>
              <li>
                <strong>Service Providers:</strong> We may share information
                with vendors who perform services on our behalf, such as data
                analytics, cloud hosting, and marketing. These providers are
                contractually obligated to protect your data.
              </li>
              <li>
                <strong>Legal Requirements:</strong> We may disclose your
                information if required to do so by law or in response to valid
                requests by public authorities (e.g., a court or a government
                agency).
              </li>
              <li>
                <strong>Business Transfers:</strong> In the event of a merger,
                acquisition, or asset sale, your personal data may be
                transferred. We will provide notice before your data is
                transferred and becomes subject to a different privacy policy.
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Data Storage, Security, and Retention</h2>
            <h3>5.1. Security Measures:</h3>
            <p>
              We implement robust technical and organizational security measures
              to protect your personal data from unauthorized access,
              alteration, disclosure, or destruction. These measures include
              data encryption, access controls, and secure server
              infrastructure.
            </p>

            <h3>5.2. Data Retention:</h3>
            <p>
              We retain your personal data only for as long as is necessary for
              the purposes set out in this Privacy Policy, to comply with our
              legal obligations, resolve disputes, and enforce our agreements.
            </p>
          </section>

          <section>
            <h2>6. Your Data Protection Rights</h2>
            <ul>
              <li>
                The right to access: You can request copies of your personal
                data.
              </li>
              <li>
                The right to rectification: You can request that we correct any
                information you believe is inaccurate or complete information
                you believe is incomplete.
              </li>
              <li>
                The right to erasure: You can request that we erase your
                personal data, under certain conditions.
              </li>
              <li>
                The right to restrict processing: You can request that we
                restrict the processing of your personal data, under certain
                conditions.
              </li>
              <li>
                The right to object to processing: You can object to our
                processing of your personal data, under certain conditions.
              </li>
              <li>
                The right to data portability: You can request that we transfer
                the data that we have collected to another organization, or
                directly to you, under certain conditions.
              </li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at the details
              provided below.
            </p>
          </section>

          <section>
            <h2>7. Use of Cookies and Tracking Technologies</h2>
            <p>
              Cookies are small files placed on your device that enable certain
              features and functionality. We use them to:
            </p>
            <ul>
              <li>Keep you signed in.</li>
              <li>Remember your preferences (like location or language).</li>
              <li>Understand how you use our site to improve it.</li>
              <li>Deliver relevant advertising.</li>
            </ul>
            <p>
              You can instruct your browser to refuse all cookies or to indicate
              when a cookie is being sent. However, if you do not accept
              cookies, you may not be able to use some portions of our Service.
            </p>
          </section>

          <section>
            <h2>8. Children’s Privacy</h2>
            <p>
              Our Service is not intended for use by anyone under the age of 18
              ("Children"). We do not knowingly collect personally identifiable
              information from children. If you are a parent or guardian and you
              are aware that your child has provided us with personal data,
              please contact us.
            </p>
          </section>

          <section>
            <h2>9. Cross-Border Data Transfers</h2>
            <p>
              Your information may be transferred to - and maintained on -
              computers located outside of Nigeria where the data protection
              laws may differ. We will take all steps reasonably necessary to
              ensure that your data is treated securely and in accordance with
              this Privacy Policy.
            </p>
          </section>

          <section>
            <h2>10. Policy Updates and Notification</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page
              and updating the "Last Updated" date. You are advised to review
              this Privacy Policy periodically for any changes.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions, concerns, or complaints about this
              Privacy Policy or our data handling practices, please contact our
              Data Protection Officer at: <br />
              TrendBay Daily Solutions Ltd <br />
              Email:{" "}
              <a href="mailto:help@trendbayds.com">help@trendbayds.com</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
